import { createContext, useContext } from 'react';
import type { ResolvedTheme, ThemePref } from './theme';

/**
 * App theme state (cue-forge-c6b). `pref` is the user's tri-state choice,
 * `resolved` is the concrete light/dark the stylesheet renders (the provider
 * mirrors it onto `<html data-theme>`). Kept component-free so the provider file
 * can satisfy react-refresh's components-only rule.
 */
export interface ThemeValue {
  /** The user's choice: light, dark, or follow the system. */
  pref: ThemePref;
  /** The concrete theme currently applied (system resolved via prefers-color-scheme). */
  resolved: ResolvedTheme;
  /** Set and persist the preference. */
  setPref: (pref: ThemePref) => void;
}

export const ThemeContext = createContext<ThemeValue | null>(null);

/** Access theme state. Must be used within a ThemeProvider. */
export function useTheme(): ThemeValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within a ThemeProvider');
  return ctx;
}
